export default __webpack_public_path__ + "static/media/rocco-potato.11fb9f09.png";